import styled from "styled-components";
import { StyledSelectInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";

import { CustomCardBody } from "../../../../components/Common/CustomCardStyled";

export const ScrollableCardBody = styled(CustomCardBody)`
    max-height: 500px;
    overflow-y: scroll;
`;

export const HiddenAvGroup = styled(AvGroup)`
    display: none;
`;

export const DimmedSelectInput = styled(StyledSelectInput)`
    opacity: 0.8;
`;

export const DesignationError = styled.div`
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f46a6a;
`;
